import { Entity } from '@backstage/catalog-model';
import { ResponseError } from '@backstage/errors';
import { DefaultApiClient, Score } from '../schema/openapi';

export class ScorecardApiClient {
  private defaultApiClient: DefaultApiClient;

  constructor(options: {
    discoveryApi: { getBaseUrl(pluginId: string): Promise<string> };
    fetchApi?: { fetch: typeof fetch };
  }) {
    this.defaultApiClient = new DefaultApiClient(options);
  }

  async getScores(entity: Entity): Promise<Score[]> {
    const response = await this.defaultApiClient.getScores({
      path: {
        namespace: entity.metadata.namespace ?? 'default',
        kind: entity.kind,
        name: entity.metadata.name,
      },
    });

    if (!response.ok) {
      throw await ResponseError.fromResponse(response);
    }

    return response.json();
  }
}
